import {onBeforeUnmount, onMounted, ref} from "vue";

/**
 * Composable to toggle experimental features with Ctrl + X.
 */
const useExperimentalFeatures = () => {
    const enabled = ref(false);

    const toggle = (event: KeyboardEvent) => {
        if (event.key === 'x' && event.ctrlKey) {
            enabled.value = !enabled.value;
        }
    };

    onMounted(() => {
        window.addEventListener('keydown', toggle);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('keydown', toggle);
    });

    return {
        enabled
    };
};

export default useExperimentalFeatures;
